import _ from 'lodash';
import { MutationTree } from 'vuex';
import { FiltersSeismograms, FiltersState } from '@/models/states/filters-state.model';

export const mutations: MutationTree<FiltersState> = {
  onUpdateFilters(state, payload: FiltersSeismograms) {
    state.filters = _.extend({}, state.filters, payload);
  },
};
